{
  "polygons": [
    [
      {
        "latitude": 45.4938224310594,
        "longitude": -73.5790675793437
      },
      {
        "latitude": 45.4936253317537,
        "longitude": -73.5787278267861
      },
      {
        "latitude": 45.4938485663982,
        "longitude": -73.578464404337
      },
      {
        "latitude": 45.4938347082701,
        "longitude": -73.5784404879638
      },
      {
        "latitude": 45.4938823658608,
        "longitude": -73.5783841887415
      },
      {
        "latitude": 45.49389163144,
        "longitude": -73.5783999809559
      },
      {
        "latitude": 45.4939229605407,
        "longitude": -73.578363117757
      },
      {
        "latitude": 45.493910878984,
        "longitude": -73.5783422413871
      },
      {
        "latitude": 45.4941040322076,
        "longitude": -73.5781141243649
      },
      {
        "latitude": 45.4941111110426,
        "longitude": -73.5781260965672
      },
      {
        "latitude": 45.4942034157231,
        "longitude": -73.5780171102815
      },
      {
        "latitude": 45.4941860040851,
        "longitude": -73.5779871135714
      },
      {
        "latitude": 45.4943716169905,
        "longitude": -73.577767934105
      },
      {
        "latitude": 45.4943922272942,
        "longitude": -73.5778036071554
      },
      {
        "latitude": 45.4944351389261,
        "longitude": -73.5777531697142
      },
      {
        "latitude": 45.4944025217638,
        "longitude": -73.5776941232604
      },
      {
        "latitude": 45.4944086795991,
        "longitude": -73.5776357197305
      },
      {
        "latitude": 45.4944430329004,
        "longitude": -73.5776003421639
      },
      {
        "latitude": 45.4946956374377,
        "longitude": -73.5780392058659
      },
      {
        "latitude": 45.4943622108617,
        "longitude": -73.5784295241273
      },
      {
        "latitude": 45.4943695640644,
        "longitude": -73.5784423565512
      },
      {
        "latitude": 45.4943013994673,
        "longitude": -73.5785228036446
      },
      {
        "latitude": 45.4942942652392,
        "longitude": -73.5785104552821
      },
      {
        "latitude": 45.4938224310594,
        "longitude": -73.5790675793437
      }
    ]
  ],
  "location": {
    "latitude": 45.494194,
    "longitude": -73.5780449
  },
  "buildingCode": "GA",
  "buildingName": "Grey Nuns Annex",
  "overview": [
    "Built in stages between 1869 and 1925, the Grey Nuns Annex originally housed workers for the Grey Nuns’ hospital complex. It once included dorms, a bakery and workshops for painters and carpenters.",
    "Acquired by Concordia in 2014, the stone building now serves as a research and administrative hub for Concordia’s Department of Education and other university services. Highlights include its preschool education lab and a modern footbridge urling it to the Faubourg (FB) Building.",
    "With its historic dormers and stone walls, the annex is a rare example of 19th-century institutional architecture preserved on campus."
  ],
  "departments": [
    {
      "name": "Education",
      "url": "https://www.concordia.ca/artsci/education.html"
    }
  ],
  "accessibility": [
    "entranceRamp",
    "entranceAutomatedDoor",
    "elevator"
  ],
  "address": "1211-1215 St-Mathieu St.",
  "campus": "SGW",
  "url": "https://www.concordia.ca/maps/buildings/ga.html"
}